/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function e(e){return e?.spatialReference?.isWebMercator||e?.spatialReference?.isGeographic||!1}export{e as canShowNorth};
